<template>
  <m-layout-stack
    :class="[
      {
        clickable: !readOnly,
        'marked-incorrect': item.isMarkedIncorrect,
      },
    ]"
    gap="1"
  >
    <m-layout-stack horizontal>
      <div>
        <span>Medication prescribed elsewhere: {{ getMainLine }}</span>
        <span v-if="item.startDateIsNotEncounterDate || item.startDateIsNotDocumentDate">
          • Started {{ item.startDate }}</span
        >
        <span v-if="item.isEnded"> • Ended {{ item.endDate ?? "" }}</span>
        <span v-if="item.additionalInformation"> • {{ item.additionalInformation }} </span>
      </div>
      <i v-if="item.isRetrospectivelyAmended" style="white-space: nowrap">{{
        formatRetrospectivelyAmendedLabel
      }}</i>
    </m-layout-stack>
  </m-layout-stack>
</template>

<script setup lang="ts">
import { computed } from "vue";

export type MedicationStatementPrescribedElsewhereJournalItem = {
  isEnded: boolean;
  prescriptionType: any;
  dosageInstructions: any;
  linkedProblems: { problemCodeDescription: string }[];
  confidentialFromThirdParties: boolean;
  hiddenFromPatientFacingServices: boolean;
  isMarkedIncorrect: boolean;
  productName: string;
  isRetrospectivelyAmended: boolean;
};

const props = defineProps<{
  item: MedicationStatementPrescribedElsewhereJournalItem;
  readOnly: boolean;
  contextHiddenFromPatientFacingServices?: boolean;
  contextConfidentialFromThirdPartyServices?: boolean;
}>();

const formatRetrospectivelyAmendedLabel = computed(() => {
  let label = [];
  if (props.item.isRetrospectivelyAmended) {
    label.push("Edited");
  }

  return label.join(" • ");
});

const getMainLine = computed(() => {
  const textAsArray = [
    props.item.productName,
    props.item.dosageInstruction,
    props.item.prescriptionType,
    props.item.prescribedByOrganisation,
  ];
  const text = textAsArray.filter((x) => x).join(" • ");
  return text === "" ? false : text;
});
</script>
